/*
    Author  : I.CUBE, inc.
    main jQuery widget of Fpmini
*/

define('planetsports',[
    'jquery',
    'jquery/ui',
    'mage/translate',
    'Born_WeltPixelGtm/js/born_gtm',
    'Magento_Customer/js/customer-data',
    'owl_carousel',
    'fancybox',
    'mage/translate'
], function($, ui, _responsive, born_gtm,customerData){
    'use strict';

    $.widget('planetsports.planetsports', {

        _create: function() {
            this.initAllPages();
        },

        initAllPages: function() {
            // START: VES_MEGAMENU search Brand
            $(document).ready(function() {
                $('#search_brand').keyup(function () {
                    var input, filter, li, a, i;
                    input = $(this);
                    filter = input.val().toUpperCase();
                    li = $('#ves_megamenu_items li');
                    for (i = 0; i < li.length; i++) {
                        a = li[i].getElementsByTagName("a")[0];
                        if (a.innerText.toUpperCase().indexOf(filter) > -1) {
                            li[i].style.display = "";
                        } else {
                            li[i].style.display = "none";
                        }
                    }
                });
            });
            // END : VES_MEGAMENU search Brand
            // ----move header links to nav section----
            $('.page-wrapper > .header.links').appendTo(".page-wrapper .sections.nav-sections .section-items");
            $('.page-wrapper .sections.nav-sections .section-items .header.links').css("display","block");
            // ----move header links to nav section----

            // ----move copyright below newsletter----
            if ($(window).width() > 639) {
                $('.page-wrapper .copyright').appendTo(".footer-container .right > .newsletter > div > .copyright");
            }
            // ----move copyright below newsletter----

            // ---- mobile menu click
            $('.top-menu.nav-mobile *').click(function() {
                var interval = setInterval(function () {
                    if ($('.top-menu.nav-mobile .navigation').hasClass("loaded")) {
                        if ( $('.top-menu.nav-mobile .navigation > .dropdown-menu').length ) {
                            $('.top-menu.nav-mobile').css({'min-height':'auto'});
                            $('.sections.nav-sections .additional-mobile').show();
                            $('.sections.nav-sections .additional-login-mobile').hide();
                            $('.sections.nav-sections #multistore-mobile-switcher-language').show();
                            $('.sections.nav-sections .store-information').show();
                            clearInterval(interval);
                        } else {
                            $('.sections.nav-sections .additional-mobile').show();
                            $('.sections.nav-sections #multistore-mobile-switcher-language').show();
                            $('.sections.nav-sections .store-information').show();
                            $('.top-menu.nav-mobile').css({'min-height':'auto'});
                            if ($(".responsive-main-header .header.links > .customer-welcome").length) {
                                $('.sections.nav-sections .additional-login-mobile').show();
                            }
                            clearInterval(interval);
                        }
                    }
                }, 50);
            });
            $(document).on('click', function(e) {
              var container = $("#suggestionsContainer");
              if (!$(e.target).closest(container).length) {
                container.addClass("ng-hide");
              }
            });
            $(document).ready(function () {
              const triggers = document.querySelectorAll('.nav-item.level0.parent');
              const overlay = document.querySelector('.overlay-div');

              function handleEnter() {
                  if($('.nav-item.level0.parent').hasClass('current')){
                    overlay.classList.add('overlay-active');
                  }
              }
              function handleLeave() {
                  overlay.classList.remove('overlay-active');
              }
              triggers.forEach(trigger => trigger.addEventListener('mouseenter', handleEnter));
              triggers.forEach(trigger => trigger.addEventListener('mouseleave', handleLeave));

              $('.checkout-cart-index .eds-discount-trigger').click(function(e){
                  e.preventDefault();
                  $('.checkout-cart-index #block-eds-discount').toggleClass('active');
                  $('.checkout-cart-index #block-eds-discount .content').slideToggle("active");
              });
              $("button.btn-success-payment").on('click', function () {
                $("#copyToClipboard").html("Copied");
              });

                // Wait to load the sub-total and other elements
                waitForElementLoad(".checkout-cart-index div#cart-totals th.mark", function() {
                    var cart = customerData.get('cart');
                    var count = cart().summary_count;
                    var checkoutData = window.checkoutConfig;

                    $('.checkout-cart-index .totals .grand.totals').hide();

                    if(count >0){
                        $(".checkout-index-index .totals.sub .mark").append('<span class="cart-title-count">(' + count + ')</span>');
                        $(".checkout-cart-index .page-title, .checkout-cart-index .totals.sub .mark").append('<span class="cart-title-count">(' + count + ')</span>');
                    }
                    $(".checkout-cart-index .payment-method-note .more-info").click(function (){
                        $(".payment-method-note img").trigger("click");
                    });
                });

                // Function to wait till the page load properly.
                function waitForElementLoad(query, callback){
                    var elemField = setInterval(function(){
                        if (document.querySelector(query)) {
                            clearInterval(elemField);
                            callback();
                        }
                    }, 1000);
                }
            });

            //Sticky Add to cart_
            if ($(window).width() < 769) {
                $('.catalog-product-view .box-tocart').addClass('pdpsticky');
            }

            // ---- mobile menu click
            // ---- STICKY HEADER ----
            if ($(window).width() < 767) {
              if (!$('body').hasClass("checkout-index-index")) {
                  var stickyTop = ($('.header-main').offset() || { "top": NaN }).top;
                  $(window).on('scroll', function () {
                      if ($(window).scrollTop() >= stickyTop) {
                          $('.header-main').css({ position: "fixed", top: "0px", width: "100%" });
                              $('.page-wrapper').css({ 'margin-top': "50px"});
                      }
                      else {
                          $('.header-main').css({ position: "relative", top: "0px" });
                          if ($(window).width() < 767) {
                              $('.page-wrapper').css({ 'margin-top': "0px"});
                          }
                      }
                  });
                  $(window).on('scroll', function () {
                    if ($(window).scrollTop() == 0) {
                        $('.header-main').css({ position: "relative", top: "0px" });
                        $('.page-wrapper').css({ 'margin-top': "0px"});
                    }
                });
              }
            }
            function stickHeight () {
                if ($(window).width() > 767) {
                    var h = $('header.page-header').height();
                } else {
                    var h = $('header.page-header').height();
                }
                $('.scroll-div').height(h);
            }
            stickHeight();
            $(window).resize(function(){
                stickHeight();
            });
            if ($(window).width() > 767){
                $(window).scroll(function(){
                    $(window).scrollTop($(window).scrollTop());
                    if ($(window).scrollTop() === 0) {
                        //$('.scroll-div').css('margin-top', 0);
                        if ($(window).width() > 767){
                            $('.header-top-wrap').slideDown('500');
                        }
                    } else {
                        //$('.scroll-div').css('margin-top', -100).addClass('sticky-header__transition--05s');
                        if ($(window).width() > 767){
                            $('.header-top-wrap').slideUp('500');
                        }
                    }
                });
            }

            $(document).ready(function(){
              var featured = $('.recomendation-slider-homepage .widget-product-grid');
              featured.owlCarousel({
                  items: 5,
                  slideSpeed: 800,
                  nav: false,
                  dots: true,
                  autoplay: false,
                  loop: false,
                  smartSpeed: 1500,
                  responsive: {
                      // breakpoint from 0 up
                      0: {
                          items: 2,
                          nav: false,
                          dots: false
                      },
                      // breakpoint from 480 up
                      480: {
                          items: 2,
                          nav: false,
                          dots: false
                      },
                      // breakpoint from 768 up
                      768: {
                          items: 4,
                          nav: true,
                          dots: false
                      },
                      // breakpoint from 768 up
                      940: {
                          items: 5,
                          nav: true,
                          dots: true,
                          dotsEach: 4,
                          slideBy: 1
                      }
                  }
              });
                $(".above-footer-container .footer-space .collapsible .title").click(function() {
                    $(this).parent().toggleClass( "open" );
                });
                $('.fotorama__zoom-in.zoom-in-loaded').on('click', function() {
                    if ($('.fotorama__zoom-out.zoom-out-loaded').hasClass('hidden')) {
                        $('.fotorama__zoom-out.zoom-out-loaded').removeClass('hidden');
                    }
                });
                var windowWidthPdp = $(window).width();
                if (windowWidthPdp < 768) {
                    $('.search-result ul li').on('click', function(){
                        setTimeout(function () {
                            $('.catalog-product-view .modal-popup').animate({scrollTop: $('#stores-map').offset().top - 100},'slow');
                        },50)
                    });
                }
                var max = 0;
                //$('.magnifier-preview').css({"width": "550px !important", "height":"550px !important"});
                $('#sizechart-id table td').each(function() {
                    max = Math.max($(this).width(), max);
                }).width(max);
                //Size chart Horizontal View
                $( ".language-dropdown-container" ).click(function() {
                    $( this ).toggleClass( "open" );
                });

                $(".footer-container .footer-space .collapsible .title").click(function() {
                    $(this).parent().toggleClass( "open" );
                });
                // ----mega menu lv 2 max 7 items per row----
                $('.mega-col-level-1 .nav-item.level1').each(function() {
                    var megaColLevel2 = $(this).find(".mega-col-level-2 .nav-item.level2");
                    var separator = $("<div class='menu-side'></div>");
                    $(megaColLevel2).each(function(i) {
                        if( i % 7 == 0 ) {
                            $(this).nextAll().addBack().slice(0,7).wrapAll(separator);
                        }
                    });
                });
                // ----mega menu lv 2 max 7 items per row ends----

                $( window ).resize(function() {
                    if ($(window).width() < 801) {
                        if ($(".responsive-main-header .header.links > .customer-welcome").length) {
                            $(".additional-login-mobile").show();
                            $(".login-mobile").hide();
                        } else if ($(".responsive-main-header .header.links > .authorization-link").length) {
                            $(".additional-login-mobile").hide();
                            $(".login-mobile").show();
                        }
                        $('.top-menu.nav-mobile').find('.active').removeClass('active');
                    } else {
                        $(".additional-login-mobile").hide();
                        $(".login-mobile").show();
                    }
                });

                var interval = setInterval(function () {
                    if ($(window).width() < 801) {
                        $('.top-menu.nav-mobile').find('.active').removeClass('active');
                        if ($(".responsive-main-header .header.links > .customer-welcome").length) {
                            $(".additional-login-mobile").show();
                            $(".login-mobile").hide();
                            clearInterval(interval);
                        } else if ($(".responsive-main-header .header.links > .authorization-link").length) {
                            $(".additional-login-mobile").hide();
                            $(".login-mobile").show();
                            clearInterval(interval);
                        }
                    } else {
                        $(".additional-login-mobile").hide();
                        $(".login-mobile").show();
                        clearInterval(interval);
                    }
                }, 1000);
            });
            //minicart mouseover event

            //searchsuggestion mobile click events
            $('[data-role="minisearch-label"]').on('click', function(){
                $(this).closest('.minisearch').addClass('search-active');
                $(this).addClass('search-active');
            });

            $(document).on("touchstart", function(e) {
                if(!$("#suggestionsContainer").is(":visible")){
                    $('[data-role="minisearch-label"]').removeClass('search-active');
                    $('.minisearch').removeClass('search-active');
                }
            });

            $('.cel-ac-icon-cancel').on('click', function(){
                $('[data-role="minisearch-label"]').removeClass('search-active');
                $('.minisearch').removeClass('search-active');
            });

            //Faq Page Email url changes starts Here
            $(document).ready(function() {
                setTimeout(function(){
                    var url = window.location.href;
                    var page = url.substring(url.lastIndexOf('/') + 1);
                    if(page == 'faq#payment'){
                        $('#payment .togglet').addClass('toggleta');
                        $('#payment .togglec').css('display','block');
                        if ($(window).width() < 768) {
                            $('html, body').animate({
                                scrollTop: $("#payment").offset().top-100
                            }, 2000);
                        }
                        if ($(window).width() > 767) {
                            $('html, body').animate({
                                scrollTop: $("#payment").offset().top-250
                            }, 2000);
                        }
                    }
                    if ($('body.catalog-product-view').length) {
                        var chartTitle = $.mage.__('Size Chart');
                        var swatchErrorTitle = $.mage.__('Choose Your Size');
                        if($(window).width() > 768) {
                            if(jQuery(".swatch-error-notice").length == 0){
                                $('.swatch-attribute[class*=size] .swatch-attribute-label').append('<div class="swatch-error-notice">' + swatchErrorTitle + '</div><a href="#" class="open-chart">' + chartTitle + '</a>');
                            }
                        }else{
                            if(jQuery(".swatch-error-notice").length == 0){
                             $('.swatch-attribute[class*=size] .swatch-attribute-label').append('<div class="swatch-error-notice">' + swatchErrorTitle + '</div>');
                             $('.swatch-attribute[class*=size]').append('<a href="#" class="open-chart">' + chartTitle + '</a>');
                            }
                        }
                        $('.product-options-wrapper .open-chart, .find-your-fit .open-chart-bottom').click(function(e){
                            e.preventDefault();
                            $.fancybox.open('#sizechart-id');
                        });
                        if(jQuery('.swatch-attribute[class*=size] .swatch-option').length == 1) {
                            $('.swatch-error-notice').hide();
                        }
                        jQuery('.actions #product-addtocart-button, .actions .buynow-button,.actions #product-updatecart-button').wrapAll('<div class="cart-wrap"></div>');
                    }
                }, 1500);
            });
            //Faq Page Email url changes Ends Here
            // ----recent blog----
            if ($(window).width() < 768) {
                $(".blog-widget-recent").addClass("mobile-carousel");
                var blog_recent = $('.blog-widget-recent.mobile-carousel .post-list');
                blog_recent.owlCarousel({
                    items: 4,
                    slideSpeed: 800,
                    nav: true,
                    dots: false,
                    loop: true,
                    responsive : {
                        // breakpoint from 0 up
                        0 : {
                            items : 1,
                            nav:false,
                            dots:false
                        },
                        // breakpoint from 481 up
                        480 : {
                            items : 2,
                            nav:false,
                            dots:false
                        },
                        // breakpoint from 481 up
                        640 : {
                            items : 3,
                            nav:false,
                            dots:false
                        }
                    }
                });

            }
            // ----recent blog----
        }
    });

    return $.planetsports.main;
});

